<template>
  <CommonLsitPage
    dataUrl="/messages/page"
    :params="pageParams"
    :requestParams="{}"
    ref="tableRef"
  ></CommonLsitPage>
  <el-dialog v-model="dialogVisible" title="确认操作" width="30%">
    <span
      >此操作将删除此条反馈
      <span style="color: red">{{ messageDetail.Title }}</span
      >，请谨慎操作。</span
    >
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="danger" @click="deleteaBannersFunction"
          >删除</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import CommonLsitPage from '../../../components/common-list-page.vue'
import moment from '../../../utils/moment'
import { ref } from 'vue'
// import { useRouter } from 'vue-router'
// import { BASE_HOST } from '../../../utils/axios'
import { ElMessage } from 'element-plus'
import { deleteMessages, putMessages } from '../../../apis'

import { Delete } from '@element-plus/icons-vue'

const tableRef = ref(null)
const dialogVisible = ref(false)

// const router = useRouter()
// const route = useRoute()
const messageDetail = ref({})
const pageParams = {
  title: '反馈消息管理',
  btns: [
    // {
    //   type: 'primary',
    //   name: '新增联系我们',
    //   onClick: () => {
    //     router.push({
    //       name: 'adminBannerOperation'
    //     })
    //   }
    // }
  ],
  // <el-table-column prop="date" label="Date" width="180" />
  tableColumn: [
    {
      label: '发布时间',
      prop: 'Pubtime',
      sortable: 'custom',
      width: 200,
      formatter: (row, column, cellValue, index) => {
        const str = moment(cellValue).format('YYYY-MM-DD  hh:mm:ss')
        // console.log(str)
        return str
      }
    },

    {
      prop: 'Title',
      label: '标题'
    },
    {
      prop: 'State',
      label: '处理状态',
      formatter: (row, column, cellValue, index) => {
        const str = cellValue ? '已处理' : '未处理'
        // console.log(str)
        return str
      }
    },

    {
      prop: 'Call',
      label: '联系人'
    },
    {
      prop: 'Tel',
      label: '联系电话'
    },
    {
      prop: 'Content',
      label: '问题描述'
    },

    {
      label: '操作',
      width: 240,
      operations: [
        {
          name: '处理',
          type: 'success',
          // icon: Edit,
          onShow: ({ row }) => {
            return row.State === 0
          },
          onClick: (scope) => {
            console.log(scope.row)
            const rowData = scope.row
            rowData.State = 1
            putMessages(rowData, rowData.Id).then((res) => {
              console.log(res, 1111)
              if (res.data.code === 200) {
                tableRef.value.refresh()
                ElMessage({
                  message: '操作成功',
                  type: 'success'
                })
              }
            })
          }
        },
        {
          name: '撤销',
          type: 'warning',
          // icon: Edit,
          onShow: ({ row }) => {
            return row.State === 1
          },
          onClick: (scope) => {
            const rowData = scope.row
            rowData.State = 0
            putMessages(rowData, rowData.Id).then((res) => {
              console.log(res, 1111)
              if (res.data.code === 200) {
                tableRef.value.refresh()
                ElMessage({
                  message: '操作成功',
                  type: 'success'
                })
              }
            })
            // console.log(tableRef.value.refresh())
          }
        },
        {
          name: '删除',
          type: 'danger',
          icon: Delete,

          onClick: (scope) => {
            messageDetail.value = scope.row
            dialogVisible.value = true
            console.log(scope, 1111)
          }
        }
      ]
    }
  ]
}

const deleteaBannersFunction = () => {
  deleteMessages(messageDetail.value.Id).then((res) => {
    tableRef.value.refresh()
    // console.log(res, '删除数据')
    dialogVisible.value = false
    ElMessage({
      message: '删除成功',
      type: 'success'
    })
  })
}
</script>

<style scoped lang="scss">
.cell-item {
  width: 6em;
}
.dec-box {
  // background: red;
}
</style>
